import React, { useEffect, useState } from "react";
import Style from "./AboutSupplier.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { getSupplierAbout } from "../../Api/BarestServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { errorToast } from "../../Toast/Toast";
import { separate } from "../../Seprate/Seprate";
const AboutSupplier = (props) => {
  const data = props.location.state;
  const [SupplierDetails, SetSupplierDetails] = useState([]);

  useEffect(() => {
    getAboutSupplier();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAboutSupplier = async () => {
    getSupplierAbout(data.id,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          SetSupplierDetails(res.about);
        }
      }else{
        console.error(res)
      }
    })
  };

  let LoadingHandler = null;
  if (SupplierDetails === undefined) {
    LoadingHandler = (
      <div className={Style.loading2Test}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    LoadingHandler =
      SupplierDetails &&
      SupplierDetails.map((item, index) => {
        return (
          <>
            <section key={index} className={Style.Spplierinfo}>
              <div className={Style.LogoHolder}>
                <img
                  src={`//cdn.barest.ir/supplier/logo/${data.logo}.jpg`}
                  alt={data.name}
                />
              </div>
              <div className={Style.infoHolder}>
                <h3>{data.name}</h3>
                <p className={Style.minPrice}>
                  حداقل سبد خرید: <span>{separate(item.min_cart)}</span> تومان
                </p>
                <p>روش پرداخت: آنلاین</p>
                <span className={Style.RateSupplier}>
                   امتیاز رستوران :  <FontAwesomeIcon icon={faStar} />
                  {parseInt(item.supplier_rate).toFixed(1)}
                </span>
              </div>
            </section>
            {item.about_us&&<section className={Style.SupplierAbout}>
              <h4>توضیحات :</h4>
              <p>{item.about_us}</p>
            </section>}
            <section className={Style.SupplierAddress}>
              <h4>آدرس:</h4>
              <p>{item.address}</p>
            </section>
            <section className={Style.SupplierTime}>
              <h4>ساعت کاری:</h4>
              <p
                className={
                  item.working_hours.start_1 === 0 ? Style.Hide : Style.TimeWork
                }
              >
                از ساعت {item.working_hours.start_1} تا ساعت{" "}
                {item.working_hours.end_1}
              </p>
              <p
                className={
                  item.working_hours.start_2 === 0 ? Style.Hide : Style.TimeWork
                }
              >
                از ساعت {item.working_hours.start_2} تا ساعت{" "}
                {item.working_hours.end_2}
              </p>
              <h5>
                درحال حاضر{" "}
                <span
                  className={
                    item.working_hours.open === "1" ? Style.Open : Style.Close
                  }
                >
                  {item.working_hours.open === "1" ? "باز" : "بسته"}
                </span>{" "}
                است
              </h5>
            </section>
          </>
        );
      });
  }

  return (
    <div>
      <section className={Style.PageHolder}>
        <BurgerMenuTitle title={` درباره ${data.name}`} />
        <hr className={Style.LineSeprator} />
        {SupplierDetails.length === 0 ? (
          <div className={Style.NotOrderFoundHolder}>
            <div className={Style.ImageBasket}>
              <img src="/Assets/Images/Order/emtyOreder.jpg" alt="برست" />
            </div>
            <p className={Style.NoOrderText}>
              درباره فروشنده مورد نظر خالی است
            </p>
          </div>
        ) : (
          LoadingHandler
        )}
      </section>
    </div>
  );
};

export default AboutSupplier;
